import axios from 'axios'

const axiosPublicClient = axios.create({
    baseURL: '/v2/api',
})

export default axiosPublicClient
